import { render, staticRenderFns } from "./TabsComponent.vue?vue&type=template&id=1ebbfa5f"
import script from "./TabsComponent.vue?vue&type=script&lang=js"
export * from "./TabsComponent.vue?vue&type=script&lang=js"
import style0 from "./TabsComponent.vue?vue&type=style&index=0&id=1ebbfa5f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports